//Belongs to HiringContract Entity
export const ExpenseManagemnetStatusEnum = Object.freeze({
  Pending: 0,
  Inprocess: 1,
  Approved: 2,
  Rejected: 3,
});

export const ExpenseManagemnetStatusLabel = Object.freeze({
  [ExpenseManagemnetStatusEnum.Pending]: "Pending",
  [ExpenseManagemnetStatusEnum.Inprocess]: "Inprocess",
  [ExpenseManagemnetStatusEnum.Approved]: "Approved",
  [ExpenseManagemnetStatusEnum.Rejected]: "Rejected",
});
